export default "__VITE_ASSET__Oidg40vB__"